import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingDevice = () => {
  const { response: device, onFetch: handleFetchDevice, loading } = useFetch(
    'player',
    Api.DEVICE
  );

  const onFetchDevice = (id) => handleFetchDevice({ pathParams: { id } });

  return {
    device,
    onFetchDevice,
    loading,
  };
};

export default useGettingDevice;
